
import InlineLoading from 'vux/src/components/inline-loading/index.vue'

import infiniteScroll from 'vue-infinite-scroll'

export default {
components: {
InlineLoading
},
directives:{
infiniteScroll
},
watch:{
'$route.params.postId':function(postId){
this.postId = postId;
console.log(postId)
this.initial();
}
},

mounted(){
this.initial()
},
data () {
return {
postId:0,
content:[],
content_loading:true,
comment_loading:true,
popular_comment_loading:true,
after:0,
busy:false,
popular_comments:[],
comments:[],
commentsLength:0,

}
},
computed:{
},
methods:{
colorful(g){
if(g==='F') return 'color:rgb(255,192,203);'
else if(g==='M') return 'color:rgb(30,144,255);'
else return
},
beautyTime(time){
let t = new Date(time);

return t.getMonth()+'月'+t.getDate()+'日 '+t.getHours()+':'+t.getMinutes()
},
initial(){
this.postId = this.$route.params.postId
this.getContent();
this.getPopularComments();
this.getComments();
},
getContent(){

let api = this.CORS + 'https://www.dcard.tw/_api/posts/';

this.content_loading = true;
this.$http.get(api+this.postId).then((response)=>{
this.content = response.data;
this.content_loading=false
console.log(response)
}).catch((err)=>{
console.log("error:");
console.log(err);
this.content_loading="error"
})
},
getPopularComments(){

let api = this.CORS + 'https://www.dcard.tw/_api/posts/';
this.comment_loading = true;
this.$http.get(api+this.postId+'/comments',{
params:{
popular:true
}
}).then(response=>{
this.popular_comments = response.data
this.popular_comment_loading=false
}).catch((err)=>{
console.log("error:");
console.log(err);
this.popular_comment_loading="error"
})
},

getComments(){
if(this.busy) return;
this.busy = true;



let api = this.CORS + 'https://www.dcard.tw/_api/posts/';
this.comment_loading = true;
this.$http.get(api+this.postId+'/comments',{
params:{
after:this.after
}
}).then(response=>{
this.commentsLength = response.data.length;
if(this.commentsLength===30){
this.after += 30;
this.busy = false;
}
else this.busy=true;
this.comments = this.comments.concat(response.data);
this.comment_loading=false
}).catch((err)=>{
console.log("error:");
console.log(err);
this.comment_loading="error"
this.busy = true
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/postContent.vue